export default () => ({
    video: null,
    observer: null,
    isLoaded: false,
    isPriority: false,
    disableMobile: false,
    prefersReducedMotion: false,
  
    init() {
      this.video = this.$el.querySelector('[data-autoplay-video]');
  
      if (!this.video) {
        return;
      }
  
      this.isPriority = this.video.dataset.autoplayVideoPriority === 'true';
      this.disableMobile = this.$el.dataset.autoplayVideoDisableMobile === 'true';
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
      if (this.shouldSkipAutoplay()) {
        return;
      }
  
      if (this.isPriority) {
        this.load();
        this.play();
        return;
      }
  
      this.observe();
    },
  
    shouldSkipAutoplay() {
      if (this.prefersReducedMotion) {
        return true;
      }
  
      if (this.disableMobile && window.matchMedia('(max-width: 767px)').matches) {
        return true;
      }
  
      return false;
    },
  
    observe() {
      if (!('IntersectionObserver' in window)) {
        this.load();
        this.play();
        return;
      }
  
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.load();
              this.play();
            } else {
              this.pause();
            }
          });
        },
        {
          root: null,
          threshold: 0.25,
          rootMargin: '120px 0px',
        }
      );
  
      this.observer.observe(this.$el);
    },
  
    load() {
      if (!this.video || this.isLoaded) {
        return;
      }
  
      const sources = this.video.querySelectorAll('source[data-src]');
  
      sources.forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
  
      this.video.load();
      this.isLoaded = true;
    },
  
    play() {
      if (!this.video || !this.isLoaded) {
        return;
      }
  
      const playPromise = this.video.play();
  
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    },
  
    pause() {
      if (!this.video) {
        return;
      }
  
      this.video.pause();
    },
  
    destroy() {
      if (this.observer) {
        this.observer.disconnect();
      }
  
      this.pause();
    },
  });